export enum ElementGroup {
	BaseElement = 'BASE_ELEMENT_GROUP',
	WallElement = 'WALL_ELEMENT_GROUP',
	EquipmentElement = 'EQUIPMENT_ELEMENT_GROUP',
	MerchandisingElement = 'MERCHANDISING_ELEMENT_GROUP'
}
